import { post } from 'src/tools/server';
//portal/stockSupplier
const addSupplier = (body) => {
  return post(`/portal/stockSupplier`, body, {});
};
export { addSupplier };
